import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import OcurrenceRepository from '@/shared/http/repositories/realestate/ocurrence'
import inputnewboll from '@/views/private/realestate/ocurrence/components/addocurrence/components/inputnewboll.vue'
import EnterpriseNewUnit from '@/shared/http/repositories/realestate/enterprisenewunit'

export default {
  name: 'InfoSorting',
  mixins: [ActionsForm, ExpenseMixin],
  props:
  {
    dataDetails: {
      type: Object,
      default: {}
    },
    statusOcorencia: {
      type: Number,
      default: 0
    },
    valorAba: {
      type: Number,
      default: 0
    }
  },
  components: {
    HeadDetailsGama,
    inputnewboll
  },
  data () {
    return {
      flDisable: false,
      problemaRaizArray: [],
      dataallenterprise: [],
      dataallpatologia: [],
      dataallenterpriseNewunity: [],
      tipo: null,
      campoUnidade: '',
      nomeUnidade: '',
      horario: null,

      tabIndexCall: 0,
      dataDetailsPdf: {},
      technicalvisit: false,
      flagpdfview: false,
      logtab: false,
      variavelaba: 0
    }
  },
  watch: {
    statusOcorencia (newvalue) {
      this.flDisable = newvalue >= 2 || newvalue < 0
    }
  },
  mounted () {
    this.getInfoPdf()
    this.getAllEnterprise()
    this.GetProblemaRaiz()
    this.getPatologia()
    // this.getunityenterprise()
    this.getTriagembyid(this.dataDetails)
    this.flDisable = this.statusOcorencia >= 2 || this.statusOcorencia < 0
  },
  methods: {
    getTriagembyid (e) {
      let id = e.id
      OcurrenceRepository.GetTriagemById(id)
        .then((res) => {
          this.dataDetails = res.data
          this.tipo = res.data.empreendimento.tipo
          this.TipoUnidadeEmpreendimentos(this.tipo)
          this.dataDetails.horarioFormatado = this.dataDetails.horarioFormatado.replace(',', ':')
        })
        .catch(() => {})
    },
    TipoUnidadeEmpreendimentos (tipo) {
      if (tipo !== null || tipo !== undefined) {
        if (tipo === 0) {
          this.campoUnidade = 'Unidade'
        } else if (tipo === 1) {
          this.campoUnidade = 'Lote'
        } else {
          this.campoUnidade = 'Casa'
        }
      }
    },
    getAllEnterprise () {
      EnterpriseNewUnit.GetNovaUnidade()
        .then((Response) => {
          this.dataallenterprise = []
          Response.data.forEach(i => {
            this.dataallenterprise.push({
              id: i.id,
              nomeUnidade: i.nomeEmpreendimento
            })
          })
        })
        .catch((Error) => {

        })
    },
    getunityenterpriseNewUnit () {
      loading.push()
      EnterpriseNewUnit.EmpreendimentoNovaUnidadeId(this.dataDetails.empreendimentoNovaUnidadeId)
        .then((Response) => {
          this.dataDetails.empreendimentoNovaUnidade = Response.data[0]
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onSubmit () {
      var repleceHorario = this.dataDetails.horarioFormatado.replace(/:/g, '.')
      var formatado = parseFloat(repleceHorario)
      let trocadeaba = 1
      this.dataDetails.horario = formatado
      loading.push()
      OcurrenceRepository.PutTriagem(this.dataDetails)
        .then(res => {
          this.$emit('goTovisitTechnical', trocadeaba)
          toast.success(`Alterações salvas com sucesso`)
          this.$emit('updateView', false)
          loading.pop()
        })
        .catch((e) => {
          toast.error(e.response.data)
          loading.pop()
        })
    },
    formatHours (hour) {
      if (!hour.toString().includes('.')) {
        if (!hour.toString().includes(':')) {
          return hour.toString() + ':00'
        }
        if (hour.toString().length === 4) {
          return hour.toString() + '0'
        }
      } else {
        return hour.toString().replace('.', ':') + '0'
      }
    },
    backPage () {
      document.location.reload()
    },
    GetProblemaRaiz () {
      loading.push()
      OcurrenceRepository.GetProblemaRaiz()
        .then(Response => {
          this.problemaRaizArray = Response.data
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
        })
    },
    getPatologia () {
      loading.push()
      OcurrenceRepository.GetPatologia()
        .then((Response) => {
          loading.pop()
          this.dataallpatologia = Response.data
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    onDownloadIncome (id) {
      OcurrenceRepository.DownloadPDF(id)
        .then(res => {
          if (res.status === 200) {
            let dataDetails = res.data.data
            const linkDownload = document.createElement('a')
            linkDownload.href = `data:image/png;base64,${dataDetails.arquivo}`
            linkDownload.download = `${dataDetails.descricao}.${dataDetails.extensao}`
            linkDownload.click()
            URL.revokeObjectURL(linkDownload.href)
          }
        })
    },
    openpopPdf () {
      this.$refs['popup-pdf-modal'].show()
      this.$nextTick(() => {
        this.getInfoPdf()
      })
    },
    getInfoPdf () {
      loading.push()
      OcurrenceRepository.GetInfoPdf(this.dataDetails.id)
        .then((Response) => {
          this.dataDetailsPdf = Response.data
          for (let i = 0; i < this.dataDetailsPdf.patologia.length; i++) {
            const checkbox = document.getElementById('check-patologia-' + i)
            if (checkbox !== null) {
              checkbox.checked = true
            }
          }
          loading.pop()
          if (this.flagpdfview) this.generatePDF()
          this.flagpdfview = true
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    closeModal () {
      this.$refs['popup-pdf-modal'].hide()
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/components/InfoSorting/infoSorting.js